import { CommonData } from '../common_schema'

export const transactionData: CommonData[] = [
  {
    name: 'Transaction OPS(total)',
    mean: 'TPS:total.values.mean',
    std: 'TPS:total.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction OPS'
  },
  {
    name: 'Transaction OPS_Source_Top1',
    mean: 'SQL_execute_count_top1:by_orthogonality.values.mean',
    std: 'SQL_execute_count_top1:by_orthogonality.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction OPS'
  },
  {
    name: 'Transaction Types Per second(2PC)',
    mean: '2PC_dominated_top1:by_type.values.mean',
    std: '2PC_dominated_top1:by_type.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction Types Per second'
  },
  {
    name: 'Transaction Types Per second(1PC)',
    mean: '1PC_dominated_top1:by_type.values.mean',
    std: '1PC_dominated_top1:by_type.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction Types Per second'
  },
  {
    name: 'Transaction Types Per second(async commit)',
    mean: 'Async_Commmit_Dominated_top1:by_type.values.mean',
    std: 'Async_Commmit_Dominated_top1:by_type.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction Types Per second'
  },
  {
    name: 'Transaction Duration(total,p99)',
    mean: 'P99_transaction_duration:total.values.mean',
    std: 'P99_transaction_duration:total.values.std',
    location:
      'Dev Tier TiDB in One Screen --> TiDB Usage --> Transaction Duration(p99)'
  },
  {
    name: 'Transaction Duration(optimistic/pessimistic,p99), unit=second',
    mean: 'P99_transaction_duration:by_type.values.mean',
    std: 'P99_transaction_duration:by_type.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction Duration'
  },
  {
    name: 'Transaction Retry Number(Total)',
    mean: 'Transaction_retry_count:total.values.mean',
    std: 'Transaction_retry_count:total.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction Retry Num'
  },
  {
    name: 'Pessimistic Statement Retry OPS',
    mean: 'Pessimistic_retry_count:total.values.mean',
    std: 'Pessimistic_retry_count:total.values.std',
    location: 'TiDB-Details --> Transaction --> Pessimistic Statement Retry OPS'
  },
  {
    name: 'Transaction Write Size Bytes Rate(average between TiDB)',
    mean: 'Txn_write_size_bytes_avg:total.values.mean',
    std: 'Txn_write_size_bytes_avg:total.values.std',
    location:
      'TiDB-Details --> Transaction --> Transaction Write Size Bytes Rate and sum'
  },
  {
    name: 'Transaction Write Size Bytes Rate(delta between cross TiDB)',
    mean: 'Txn_write_size_bytes_delta:total.values.mean',
    std: 'Txn_write_size_bytes_delta:total.values.std',
    location:
      'TiDB-Details --> Transaction --> Transaction Write Size Bytes Rate and sum'
  },
  {
    name: 'Scheduler Flow(average between TiKV)',
    mean: 'Scheduler_flow_average:total.values.mean',
    std: 'Scheduler_flow_average:total.values.std',
    location: 'TiKV-Details --> Flow Control --> Scheduler Flow'
  },
  {
    name: 'Commit Token Wait Duration',
    mean: 'P99_commit_token_duration:total.values.mean',
    std: 'P99_commit_token_duration:total.values.std',
    location: 'TiDB-Details --> Transaction --> Commit Token Wait Duration'
  }
]
